import * as React from 'react';
import { AppButtonTypes, ButtonProps } from './ButtonProps'

import './ButtonStyles.scss'
import clsx from 'clsx'

const Button = ({ onClick, className, buttonContent, uiButtonType, isLoading, disabled, ...others } : ButtonProps) => {

   const handleButtonOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      if ((typeof onClick === 'function') && (isLoading === undefined || isLoading === false)) {
         onClick(e)
      }
      else {
         return
      }
   }

   return (
      <div className='page-main-button-outer-wrapper'>
         <button
            style={{ position: 'relative' }}
            disabled={disabled || isLoading}
            className={clsx(
               className && className, 
               uiButtonType === AppButtonTypes.PRIMARY && 'page-main-button-primary', 
               uiButtonType === AppButtonTypes.SECONDARY && 'page-main-button-secondary',
               uiButtonType === AppButtonTypes.OUTLINED_PRIMARY && 'page-main-button-outlined-primary',
               uiButtonType === AppButtonTypes.OUTLINED_SECONDARY && 'page-main-button-outlined-secondary',
            )} 
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleButtonOnClick(e)} 
            {...others}
         >
            {isLoading ? <span className="page-main-button-loader-spinner"></span> : buttonContent}
         </button>
      </div>
   )
}

export default Button;